<template>
  <div class="bg-white loginBox">
    <phone
      class="margin20-bottom"
      @phoneEmit="phoneEmit"
      :placeholder="phonePholder"
    ></phone>
    <password
      class="margin20-bottom"
      @pwdEmit="pwdEmit"
      :placeholder="pwdPholder"
    ></password>
    <div class="padding15-top" @click="btnClick">
      <btn :btnCol="btnColor" :btnText="btnText"></btn>
    </div>
    <div class="row cen-between padding15-top gray-8 ft14">
      <span @click="goRetrievePwd">找回密码</span>
      <span @click="goRegister">免费注册</span>
    </div>
    <toast ref="toast"></toast>
  </div>
</template>

<script>
import Phone from "@/components/input/phone";
import Password from "@/components/input/password";
import Btn from "@/components/input/button";
import Toast from "@/components/toast/tosatInfo";
import { CacheModule } from "@/utils/commonUtils.js";

import { loginPwd } from "@/model/user/userServe";
import { mutations } from "@/observable/store";
export default {
  name: "pwdLogin",
  data() {
    return {
      phonePholder: "请输入手机号",
      pwdPholder: "密码",
      btnText: "登录",
      phoneObj: {},
      btnColor: false,
      pwdObj: {},
    };
  },
  components: {
    Phone,
    Password,
    Btn,
    Toast,
  },
  watch: {
    phoneObj(val) {
      if (val.name && this.pwdObj.name) {
        this.btnColor = true;
      }
    },
    pwdObj(val) {
      if (val.name && this.phoneObj.name) {
        this.btnColor = true;
      }
    },
  },
  methods: {
    phoneEmit(e) {
      this.phoneObj = e;
    },
    pwdEmit(e) {
      this.pwdObj = e;
    },
    btnClick() {
      if (this.phoneObj && !this.phoneObj.phoneFlag) {
        return;
      }
      if (this.pwdObj && !this.pwdObj.pwdFlag) {
        this.$refs.toast.showToast("密码格式有误");
        return;
      }
      let params = {
        loginname: this.phoneObj.name, //登录手机号
        pwd: this.pwdObj.name, //登录密码
      };
      loginPwd(params).then((data) => {
          CacheModule.set("loginPhone", this.phoneObj.name);
          CacheModule.set("setToken", data.data.token);
          mutations.getToken(data.data.token);

          if (this.$route.query.pathLogin) {
            this.$router.push({
              path: this.$route.query.pathLogin,
            });
          } else {
            this.$router.push({
              path: "/",
            });
          }
        }).catch((error) => {
          this.$refs.toast.showToast(error.message);
        });
    },
    goRetrievePwd() {
      this.$router.push({
        path: "/retrievePwd",
        query: {
          pathLogin: this.$route.query.pathLogin,
        },
      });
    },
    goRegister() {
      this.$router.push({
        path: "/register",
        query: {
          pathLogin: this.$route.query.pathLogin,
        },
      });
    },
  },
};
</script>
<style scoped lang="less">
.loginBox {
  width: 100%;
  box-sizing: border-box;
  padding: 1rem 0.75rem 0;
}
</style>
